import React from 'react';
import {
  Box,
  ButtonBase,
  Drawer,
  FormControlLabel,
  IconButton,
  Typography,
} from '@material-ui/core';

import SMCheckBox from 'components/Common/SMCheckBox';
import { get } from 'lodash';
import SubOptionPopover from './SubOptionPopover';
import { KeyboardArrowDown } from '@material-ui/icons';
import { subOptionFormAvailable } from './SubOptionForm';
import DynamicIcon from 'components/Common/DynamicIcon';
import SubInputsDrawer from './SubInputsDrawer';

const RadioInputCell = ({
  row,
  column,
  columns,
  rowState,
  handleRowChange,
  setPreview,
  index,
  rowIndex,
}) => {
  const [anchorElement, setAnchorElement] = React.useState();
  const [subInputsDrawerOpen, setSubInputsDrawerOpen] = React.useState(false);
  const [subInputsDrawerTitle, setSubInputsDrawerTitle] = React.useState('');
  // const [open, setOpen] = React.useState(false);
  const anchorOriginRef = React.useRef({});
  let open = !!anchorElement;

  React.useEffect(() => {
    const selectedOption =
      (column.options || [])[
        (rowState || {})[column.key] || (row[column.key] || {}).value
      ] || undefined;

    if (!selectedOption) {
      handleRowChange(row.id, { [column.key]: null });
    } else {
      handleRowChange(row.id, {
        [column.key]:
          (rowState || {})[column.key] || (row[column.key] || {}).value || null,
        ...(selectedOption
          ? {
              [selectedOption.key]:
                row[column.key][selectedOption.key] ||
                selectedOption[selectedOption.key],
            }
          : {}),
      });
    }

    const previewContent =
      get(rowState, (selectedOption || {}).key) ||
      get(row, [column.key, (selectedOption || {}).key]) ||
      get(selectedOption, (selectedOption || {}).key);

    setPreview(
      index,
      previewContent
        ? {
            type: (selectedOption || {}).id,
            items: previewContent,
          }
        : {}
    );
  }, [row]);

  const handleSelectionChange = (option) => {
    handleRowChange(
      row.id,
      {
        [column.key]: option.id,
        ...(rowState[option.key] || option[option.key]
          ? { [option.key]: rowState[option.key] || option[option.key] }
          : {}),
      },
      rowState[column.key] === +option.id
        ? []
        : [
            (
              column.options[
                rowState[column.key] || (row[column.key] || {}).value
              ] || {}
            ).key,
          ]
    );

    const previewContent =
      get(rowState, (option || {}).key) ||
      get(row, [column.key, (option || {}).key]) ||
      get(option, (option || {}).key);

    setPreview(
      index,
      previewContent
        ? {
            type: option.id,
            items: previewContent,
          }
        : {}
    );
  };

  const setSubOptions = (value, rowId) => {
    handleRowChange(rowId, {
      [(
        column.options[rowState[column.key] || (row[column.key] || {}).value] ||
        {}
      ).key]: value,
    });
    setPreview(
      index,
      value
        ? {
            type: rowState[column.key],
            items: value,
          }
        : {}
    );
  };

  const closePopover = () => {
    setAnchorElement(null);
  };

  React.useEffect(() => {
    const selectedOption =
      (column.options || [])[
        (rowState || {})[column.key] || (row[column.key] || {}).value
      ] || undefined;

    setSubOptions((rowState || {})[(selectedOption || {}).key] || [], row.id);
  }, [rowState]);

  return (
    // TODO change component signature based on formHandling
    <div
      style={{ maxWidth: '100%', overflow: 'auto', padding: '0px 5px 5px 0px' }}
    >
      <Box
        style={{
          display: 'flex',
          flex: 1,
          flexWrap: 'wrap',
          minWidth: 200,
          maxWidth: '100%',
        }}
      >
        {Object.keys(column.options || []).map((option) => {
          return (
            <>
              <div
                style={{
                  // display: 'inline-block',
                  minWidth: 150,
                  maxWidth: 200,
                  display: 'flex',
                  flex: 1,
                  justifyContent: 'space-between',
                  marginRight: 5,
                  ...((rowState[column.key] ||
                    (row[column.key] || {}).value) === +option
                    ? {
                        border: '1px solid #d5d5d5',
                        borderRadius: 7,
                        ...(subOptionFormAvailable.includes(
                          rowState[column.key] || (row[column.key] || {}).value
                        )
                          ? {}
                          : {}),
                      }
                    : {}),
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SMCheckBox
                      checked={
                        (rowState[column.key] ||
                          (row[column.key] || {}).value) === +option
                      }
                      onClick={() =>
                        handleSelectionChange({
                          ...(column.options[option] || {}),
                          id: +option,
                        })
                      }
                      style={{ padding: 0, marginRight: 8, marginLeft: 5 }}
                    />
                    <Typography
                      style={{
                        color: (row[column.key] || {})['color'] || '#505050',
                        padding: '8px 0px',
                        marginLeft: 0,
                      }}
                    >
                      {(column.options[option] || {}).title}
                    </Typography>
                  </div>
                </div>

                {subOptionFormAvailable.includes(+option) && (
                  <IconButton
                    disabled={
                      !(
                        (rowState[column.key] ||
                          (row[column.key] || {}).value) === +option
                      )
                    }
                    style={{
                      marginRight: 5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      outline: 'none',
                    }}
                    onClick={(event) => {
                      const { innerWidth: width, innerHeight: height } = window;
                      const {
                        x,
                        y,
                      } = event.currentTarget.getBoundingClientRect();
                      anchorOriginRef.current.origin = {
                        vertical: y > 3 * (height / 4) ? 'top' : 'bottom',
                        horizontal: 'left',
                      };
                      setAnchorElement(event.currentTarget);
                    }}
                  >
                    <KeyboardArrowDown
                      style={{
                        fontSize: 25,
                        color:
                          (rowState[column.key] ||
                            (row[column.key] || {}).value) === +option
                            ? '#505050'
                            : '#a5a5a5',
                        pading: 0,
                        marginLeft: -0.1,
                      }}
                    />
                  </IconButton>
                )}
              </div>
              <SubOptionPopover
                row={row}
                rowState={rowState}
                column={column}
                open={open}
                origin={anchorOriginRef.current.origin}
                anchorElement={anchorElement}
                setOpen={closePopover}
                selectedType={
                  rowState[column.key] || (row[column.key] || {}).value
                }
                handleChange={(value) => setSubOptions(value, row.id)}
              />
            </>
          );
        })}
      </Box>
      {subOptionFormAvailable.includes(
        rowState[column.key] || (row[column.key] || {}).value
      ) &&
        (column.actions || []).map((action) => (
          <ButtonBase
            style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}
            onClick={() => {
              setSubInputsDrawerTitle((action.title || '').toUpperCase());
              setSubInputsDrawerOpen(true);
            }}
          >
            <Typography style={{ color: '#7467F0' }}>
              {(action || {}).title}
            </Typography>
            <DynamicIcon
              iconId={(action || {}).iconId}
              style={{ width: 9, height: 9, marginLeft: 15 }}
            />
          </ButtonBase>
        ))}
      <SubInputsDrawer
        row={row}
        rowState={rowState}
        title={subInputsDrawerTitle}
        rowIndex={rowIndex}
        column={column}
        columns={columns}
        open={subInputsDrawerOpen}
        anchorElement={anchorElement}
        setOpen={setSubInputsDrawerOpen}
        selectedType={rowState[column.key] || (row[column.key] || {}).value}
        handleChange={(value) => setSubOptions(value, row.id)}
      />
    </div>
  );
};

export default RadioInputCell;
